import React, { useRef, useEffect } from 'react';
import { select as d3select } from 'd3-selection';
import { interpolate as d3interpolate } from 'd3-interpolate';
import 'd3-transition';

import {humanizeNumber} from "core/ui/charts/chart-base";

// Tween function generator for count transition animation
// Extra attribute allows for props for showing full number verses shortend number.
const tweenCount = function(toVal){
  const el = this;
  const fromVal = el._lastVal || 0;
  const step = d3interpolate(fromVal, toVal);
  el._lastVal = step(1); // 1 == "100%", a.k.a. the "end" of tween.
  return (t)=> {
    const val = step(t);
    const showFullNumber = el.getAttribute("data-fullnumber");
    el.innerText = humanizeNumber(val, showFullNumber);
  }
};

const TweenedNumber = React.memo(({ value, fullNumber, className }) => {
  const elRef = useRef(null);
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      elRef.current.innerText = humanizeNumber(value, fullNumber);
    } else {
      d3select(elRef.current).data([value]).transition().duration(700).tween('text', tweenCount);
    }
  }, [value, fullNumber]);

  return <span className={className || ''} data-fullnumber={fullNumber || undefined} ref={elRef} />;
});

export default TweenedNumber;

